import counterpart from "counterpart";
import langDe from '../assets/translation/de.json';
import HundDto from "../consumer/form/dto/HundDto";
import UtfCode from "./util/UtfCode";

// Quelle:
// https://www.npmjs.com/package/counterpart

export enum AppTranslationMessage {
    APP_ERROR_MESSAGE_RETRY = 'app.error.message-retry',

    APP_MODEL_SELBSTBEHALT_FORM = "app.model.StvSelbstbehalt.form",
    APP_MODEL_SELBSTBEHALT_TEXT = "app.model.StvSelbstbehalt.text",
    APP_MODEL_SELBSTBEHALT_INFO_TEXT = "app.model.StvSelbstbehalt.info-text",
    APP_MODEL_SELBSTBEHALT_INFO_TITEL = "app.model.StvSelbstbehalt.info-titel",

    APP_MODEL_ZAHLUNGSWEISE_FORM = "app.model.StvZahlungsweise.form",
    APP_MODEL_ZAHLUNGSWEISE_TEXT_BEITRAG = "app.model.StvZahlungsweise.text-beitrag",
    APP_MODEL_ZAHLUNGSWEISE_TEXT_ZAHLUNG = "app.model.StvZahlungsweise.text-zahlung",

    APP_MODEL_ZAHLUNGSWEISE_INFO_TEXT = "app.model.StvZahlungsweise.info-text",
    APP_MODEL_ZAHLUNGSWEISE_INFO_TITEL = "app.model.StvZahlungsweise.info-titel",

    APP_MODEL_VERSICHERUNGSSUMME_FORM = "app.model.StvVersicherungssumme.form",
    APP_MODEL_VERSICHERUNGSSUMME_TEXT = "app.model.StvVersicherungssumme.text",
    APP_MODEL_VERSICHERUNGSSUMME_INFO_TEXT = "app.model.StvVersicherungssumme.info-text",
    APP_MODEL_VERSICHERUNGSSUMME_INFO_TITEL = "app.model.StvVersicherungssumme.info-titel",

    APP_MODEL_TITEL_FORM = "app.model.StvTitel.form",
    APP_MODEL_ANREDE_FORM = "app.model.StvAnrede.form",
    APP_MODEL_HUNDE_RASSE_INFO_TEXT = "app.model.HundeRasse.info-text",
    APP_MODEL_HUNDE_RASSE_INFO_TITEL = "app.model.HundeRasse.info-titel",

    APP_KAMPAGNE_TEXT = "app.kampagne.text"
}

const setUpCounterpartTranslation = () => {
    counterpart.registerTranslations('de', langDe);
    counterpart.setLocale('de');
}

const getMessage = (message: AppTranslationMessage, key?: string) => {
    const msg = key ? `${message}.${key}` : message
    return counterpart(msg);
}

const getProduktTitelAngebot = (hunde: HundDto[]) => {
    const TITEL_TEXT_HUNDE = `Unser Versicherungs${UtfCode.SOFT_HYPHEN}angebot für`;

    const hundeAnzahl = hunde.length;
    return hundeAnzahl > 2 ? `${TITEL_TEXT_HUNDE} Ihre Vierbeiner` :
        hundeAnzahl === 2 ? `${TITEL_TEXT_HUNDE} ${hunde[0].name} und ${hunde[1].name}` :
            `${TITEL_TEXT_HUNDE} ${hunde[0].name}`;
}

const getProduktTitelAntrag = (schutzbrief: boolean) => {
    return `Ihre HUNDE${UtfCode.NON_BREAKING_HYPHEN}HAFTPFLICHT+ \n${schutzbrief ? 'mit' : 'ohne'}${UtfCode.NO_BREAK_SPACE}Schutzbrief`;
}

const AppTranslation = {
    setUpCounterpartTranslation,
    getMessage,
    getProduktTitelAngebot,
    getProduktTitelAntrag
}

export default AppTranslation;